module.exports = __webpack_public_path__ + "assets/pride-logo-d74ea2.svg";